import cn from "classnames";

const SettingsButton = ({ onClick, disabled, children, className}) => {
    return (
        <button
            type="button"
            disabled={disabled}
            className={cn("bg-transparentpy-2 p-4 min-h-12 min-w-20 rounded-lg border items-center", className)}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export default SettingsButton;
